/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import * as S from "./styles";
import { useTheme } from "../../../../providers/theme";

const is = require("is_js");

export interface ILoaderProps {
  loadingText?: string;
}

export const Loader = ({ loadingText }: ILoaderProps) => {
  const theme = useTheme();

  return (
    <S.ModalBodyContainer>
      <S.SpinnerContainer animation="border" role="status" />
      {loadingText}
    </S.ModalBodyContainer>
  );
};

Loader.defaultProps = {};
